import {isMobile} from '@netx/core-next/utils/browser';
import {
	currentUserIsAdmin,
	currentUserHasSystemAccess,
} from '@netx/core-permissions-next/enablers';

export const canViewSystem = (): boolean => {
	if (isMobile()) return false;
	return currentUserHasSystemAccess();
};

export const canViewSystemLogins = (): boolean => currentUserIsAdmin();
